import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import "../styles/SignUp.css";
import "../styles/SignUpPage.css";

function CCCApplySuccess() {
    const navigate = useNavigate();

    const handleGoToDashboard = () => {
        const school = JSON.parse(localStorage.getItem("cachedUser")).school;
            
        if (school.ccc_apply_enabled) {
            navigate("/cccapply/consent");
        } else if (school.baseline_plans_enabled) {
            navigate("/baseline-plans");
        } else {
            navigate("/plan");
        }
    };

    return (
        <div className="signup-page">
            <Container className="signup-container">
                <h2 className="center-text">Reminder: Parent Signature Needed</h2>
                <p className="center-text">
                Let your parent or guardian know that they need to sign your form too! They should have received an email with a link to complete their signature.
                </p>
                <p className="center-text">
                <strong>You won’t be able to register for any college courses until your parent signs the form.</strong> Please remind them today!
                </p>

                <div className="center-text">
                    <Button 
                        variant="primary" 
                        className="btn-block custom-button" 
                        onClick={handleGoToDashboard}
                    >
                        Next
                    </Button>
                </div>
            </Container>
        </div>
    );
}

export default CCCApplySuccess;